import { clsx } from 'clsx'
import { useTranslation } from 'react-i18next'

const LastModifiedDate = ({ date, className = '' }) => {
  const { t } = useTranslation()

  if (!date) {
    return null
  }

  return (
    <div className={clsx('sp-api-viewer-last-modified text-body3 font-semibold text-(--sp-color-text-muted) font-[Open_Sans]', className)}>
      {t('consumer.product.template.lastModified', { lastModifiedDate: date })}
    </div>
  )
}

export const LastModifiedDatePlugin = ({ lastModifiedDate }) => ({
  wrapComponents: {
    InfoContainer: Original => props => (
      <div className="pt-6">
        <LastModifiedDate date={lastModifiedDate} className="pb-2" />
        <Original {...props} />
      </div>
    )
  }
})

export default LastModifiedDate